import { msg } from 'gt-react';
import { FactoryIcon } from '@phosphor-icons/react';
import { Action, Subject } from '@erp/authz';
import { ProductModule } from '@erp/shared-types';
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import {
  Route as pathlessAuthenticatedRoute,
  requireModules,
  requirePermission,
} from '../../route';

const SdSuppliersPage = lazyRouteComponent(
  () => import('./SdSuppliersPage'),
  'SdSuppliersPage',
);

export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/ship-and-debit/suppliers',
  staticData: {
    app: {
      nav: {
        label: msg('SD Suppliers', {
          context: 'sidebar nav label, Ship and Debit Admin section',
        }),
        icon: <FactoryIcon className="h-4 w-4" weight="fill" />,
        group: 'Ship and Debit Admin',
        order: 54,
      },
      access: {
        modulesAnyOf: [ProductModule.SHIP_AND_DEBIT],
        permissionsAnyOf: [{ action: Action.Read, subject: Subject.SDAdmin }],
      },
    },
  },
  component: SdSuppliersPage,
  loader: () => ({
    crumb: msg('SD Suppliers', { context: 'page breadcrumb' }),
  }),
  beforeLoad: async ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.SHIP_AND_DEBIT],
    });
    await requirePermission({
      context,
      action: Action.Read,
      subject: Subject.SDAdmin,
    });
  },
});
